import TPL = require("templates");
import {ConfirmController} from "./confirm";
import {Config} from "../config";

declare var FB: any;

export class RsvpController {

  parent;
  session;
  modal;
  location;
  currentModal;
  stripe;
  log;

  reservationData;
  cardData;
  notification;
  seatsAvailable;
  maxSeats;
  acceptedSeats;
  cardList;
  checkCard;
  showListCard;
  showParam;
  cardSelected;
  couponNumber;
  couponAmount;
  couponType;
  couponId;
  couponCheck;
  totalAmount;

  isPaying: boolean;

  constructor(parent, session, modal, location, stripe, notification, log) {
    this.parent = parent;
    this.session = session;
    this.modal = modal;
    this.location = location;
    this.stripe = stripe;
    this.notification = notification;
    this.log = log;
    this.maxSeats = this.session.getData().event.number_of_guests_max;
    this.acceptedSeats = this.session.getData().event.reservations_stats.guests_accepted;

    this.currentModal = this.parent.currentModal;
    this.cardList = this.getCardList();
    this.clearReservationData();
    this.clearCardData();
    this.showListCard = false;
    this.showParam = "showSingle";
    this.cardSelected = {
        id: ''
      };
    this.couponNumber = "";
    this.couponAmount;
    this.couponType;
    this.couponId = "";
    this.couponCheck = false;
    this.calculateAmount();
    this.reservationData.seats = 1;
  }

  clearCardData() {
    this.cardData = {
      rememberCard: true
    }
  }

  clearReservationData() {
    this.reservationData = {
      seats: 1,
      credentials: [],
      fees: 0
    }
  }

  getCardList() {
    this.session.getCardList().then(
      (response) => {
        this.cardList = response;
        if (response.length > 0) {
          angular.forEach(response, (value) => {
              if(value.favourite){
                this.cardSelected.id = value.id;
              }
          });
          this.checkCard = true;
        }
    });
  }

  changeCard (param) {
    if(param == "show") {
      this.checkCard = false;
      this.showListCard = false;
      this.showParam = "hide";
    } else {
      this.checkCard = true;
      this.showListCard = true;
    }
  }

  openListCard(param) {
    if (param === "showList"){
      //this.showListCard = true;
      this.showParam = "showSingle";
    } else {
      //this.showListCard = false;
      this.showParam = "showList";
      this.checkCard = true;
    }
  }

  verifyCoupon() {
    this.session.couponValidation(this.couponNumber).then(
      (response) => {
        this.couponAmount = response.amount;
        this.couponType = response.discount_type;
        this.couponId = response.id;
        this.couponCheck = true;

    }).then(
      () => {
        this.calculateAmount();

    }).catch((err) => {
      this.couponCheck = false;
      this.notification.error("Your coupon isn't valid!");

      this.log.debug('Coupon error', err.message);

      throw err;
    });
  }

  calculateAmount() {
    this.couponAmount = parseFloat(this.couponAmount);
    if (!this.couponType || typeof this.couponType === 'undefined' || this.couponNumber == '') {
      this.totalAmount = (this.reservationData.seats * this.session.getData().event.price_per_person/100) + this.reservationData.fees
    } else if (this.couponType == "%") {
      this.totalAmount = ((this.reservationData.seats * this.session.getData().event.price_per_person/100) + this.reservationData.fees) * (1 - (this.couponAmount/100))
    } else {
      this.totalAmount = ((this.reservationData.seats * this.session.getData().event.price_per_person/100) + this.reservationData.fees) - (this.couponAmount)
    }

    this.totalAmount = Number(this.totalAmount).toFixed(2);
    return this.totalAmount;
  }

  changeCouponCheck () {
    if (this.couponNumber === "") {
      this.calculateAmount();
      this.couponCheck = false;
      this.couponId = "";
    }
  }

  logConsole (cardId) {
      this.cardSelected.id = cardId;
      this.log.debug("Value is : " + this.cardSelected.id);
  };

  addSeat(seatsavailable) {
    if (this.reservationData.seats < seatsavailable) {
      this.reservationData.seats++;
      this.reservationData.credentials.push({});
    } else {
      this.seatsAvailable = seatsavailable;
    }

  }

  removeSeat() {
    this.reservationData.seats--;
    this.seatsAvailable = "";
    if (this.reservationData.seats < 1) {
      this.reservationData.seats = 1;
    } else {
      this.reservationData.credentials.pop();
    }
  }

  /**
    This should go back but for simplicity it will open a completely new istance
  */
  openRsvpModal() {
    if (this.currentModal) {
      this.currentModal.dismiss();
    }

    this.currentModal = RsvpController.openRsvpModal(this.modal, this, this.session, this.location, this.stripe, this.notification, this.log);
  }


  openRsvpGuestsModal() {
    if (this.currentModal) {
      this.currentModal.dismiss();
    }

    if (this.reservationData.seats > 1) {
      this.currentModal = RsvpController.openRsvpGuestsModal(this.modal, this);
    } else {
      this.openRsvpPaymentModal();
    }
  }


  openRsvpPaymentModal(guestsForm?) {

    if(this.reservationData.seats > 1 && (!guestsForm || !guestsForm.$valid)) {
      this.notification.error("Check your guests data");
      return;
    }

    if (this.currentModal) {
      this.currentModal.dismiss();
    }

    if (this.session.getData().event.price_per_person > 0) {
      this.currentModal = RsvpController.openRsvpPaymentModal(this.modal, this);
    } else {
      this.session.spinnerService.show("mainSpinner");
      this.session.reserve(this.reservationData.credentials).then(()=>{
        this.onReservationSuccess();
        this.session.spinnerService.hide("mainSpinner");
      }).catch(eventResponse => {
        if (eventResponse.status === 422){
          this.session.spinnerService.hide("mainSpinner");
          if (eventResponse.data.errors.event_date) {
            this.notification.error("Reservation deadline already reached");
          }
        }
      });
    }

  }

  isManualApproval() {
    var event = this.session.getData().event;
    if (event != null) {
        return event.event_type == "manual_approval";
    } else {
      return false;
    }
  }

  submitPayment(form) {
    if (form.$valid) {
      this.isPaying = true;

      var cardName = this.cardData.cardName;
      var cardNumber = this.cardData.cardNumber;
      var cardCvc = this.cardData.cardCvc;
      var cardMonth = this.cardData.cardMonth;
      var cardYear = this.cardData.cardYear;
      var favourite = this.cardData.cardFavourite;
      var payToken;

      var cardData = {
        number: cardNumber,
        name: cardName,
        cvc: cardCvc,
        exp_month: cardMonth,
        exp_year: cardYear
      };

      this.stripe.card.createToken(cardData)
        .then((response) => {
          this.isPaying = true;
          this.log.debug(response);
          this.log.debug('token created for card ending in ', response.card.last4);
          var payment = angular.copy(response);
          payment.card = void 0;
          payment.token = response.id;
          this.log.debug('shoud send the payment to the server');
          this.log.debug(payment);
          payToken = response.id;
          //if (favourite){
          this.log.debug(payment);
          this.log.debug(payToken);
          var data = {
            stripe_token : payToken,
            favourite: favourite
          };
          //this.session.registerNewCard(data);
          //}
          return this.session.pay(payment,this.reservationData.seats, this.reservationData.credentials,this.couponId);
        })
        .then((payment) => {

          /////////REGISTER NEW CARD////////////
          this.stripe.card.createToken(cardData)
            .then((response) => {
              var payment = angular.copy(response);
              payment.card = void 0;
              payment.token = response.id;

              payToken = response.id;
              //if (favourite){
              this.log.debug(payment);
              this.log.debug(payToken);
              var data = {
                stripe_token : payToken,
                favourite: favourite
              };
              this.session.registerNewCard(data);
              //}
          })
          //////////////////////////

          this.log.debug('successfully submitted preauthorized payment for $', payment.amount);
          this.isPaying = false;

          if (this.session.getData().event.event_type == "manual_approval") {
            this.notification.success("Payment Completed");
          }
          this.session.loadMyReservations();
          this.onReservationSuccess();

        })
        .catch((err) => {
          this.isPaying = false;

          if (err.status === 422 && err.data.errors.event_date){
            this.session.spinnerService.hide("mainSpinner");
            this.notification.error("Reservation deadline already reached");
          }
          else {
            this.notification.error("Payment Error");

            if (err.type && /^Stripe/.test(err.type)) {
              this.log.debug('Stripe error: ', err.message);
            }
            else {
              this.log.debug('Other error occurred, possibly with your API', err.message);
            }
            throw err;
          }
        });
    } else if (form.selectedCard) {
      this.isPaying = true;
      var payment = {
        card_id: this.cardSelected.id
      };
      return this.session.pay(payment,this.reservationData.seats, this.reservationData.credentials,this.couponId)
      .then((payment) => {
        this.isPaying = false;

        if (this.session.getData().event.event_type == "manual_approval") {
          this.notification.success("Payment Completed");
        }
        this.session.loadMyReservations();
        this.onReservationSuccess();
      })
      .catch((err) => {
        this.isPaying = false;
        if (err.status === 422 && err.data.errors.event_date){
          this.session.spinnerService.hide("mainSpinner");
          this.notification.error("Reservation deadline already reached");
        }
        else {
          this.notification.error("Payment Error");

          if (err.type && /^Stripe/.test(err.type)) {
            this.log.debug('Stripe error: ', err.message);
          }
          else {
            this.log.debug('Other error occurred, possibly with your API', err.message);
          }
          throw err;
        }
      });
    }
  }

  getTermsLink() {
    return Config.wp_termsandconditions;
  }

  private onReservationSuccess() {

    if (this.currentModal) {
      this.currentModal.dismiss();
    }

    var shareCallback = ()=> {
      this.log.debug("share on facebook");

      var currentEvent = this.session.data.event;
      var eventURL = Config.publicEndpoint + '#' + Config.events + '/' + currentEvent.uuid

      var currentEventPhoto = Config.publicEndpoint + 'assets/bannerless.jpg';
      if(currentEvent.cover) {
        currentEventPhoto = currentEvent.cover.m;
      }

      try {
        FB.ui({
            display: 'popup',
            method: 'feed',
            link: eventURL,
            title: currentEvent.title,
            picture: currentEventPhoto,
            description: currentEvent.description,
            caption: 'Powered by BBYO'
        }, (response) => {
          this.log.debug("response: " + response);
        });
      } catch(err) {
        this.log.debug("err: " + err);
      }
    };

    var browseCallback = ()=> {
      this.location.url(Config.home);

      if (this.currentModal) {
        this.currentModal.dismiss();
      }
    };
    var dismissCallback = ()=> {
      if (this.currentModal) {
        this.currentModal.dismiss();
      }
    };

    //TODO set corresponding dialog according to event type
    var currentEvent = this.session.data.event;
    if (currentEvent.event_type != "manual_approval") {
      this.currentModal = ConfirmController.openReservationDonePublicModal(this.modal, shareCallback, browseCallback, dismissCallback);
    } else {
      this.currentModal = ConfirmController.openReservationDoneManualModal(this.modal, shareCallback, browseCallback, dismissCallback);
    }

    this.session.loadEvent();
  }


  static openRsvpModal(modal, parent, session, location, stripe, Notification, log) {
    return modal.open({
          controller: () => new RsvpController(parent, session, modal, location, stripe, Notification, log),
          controllerAs: "vm",
          replace: true,
          size: "lg",
          template: TPL.modals.rsvp
        });
  }


  static openRsvpGuestsModal(modal, controller: RsvpController) {
    return modal.open({
          controller: () => controller,
          controllerAs: "vm",
          replace: true,
          size: "sm",
          template: TPL.modals.rsvpGuests
        });
  }

  static openRsvpPaymentModal(modal, controller: RsvpController) {
    return modal.open({
          controller: () => controller,
          controllerAs: "vm",
          replace: true,
          size: "lg",
          template: TPL.modals.rsvpPayment
        });
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/modals/rsvp.ts
 **/